const AM_PM_PATTERN = new RegExp('(\\p{N})\\s*([ap])(?:\\.m\\.|m\\b)', 'giu')

export const compactAmPm = (value: string): string =>
  value.replace(AM_PM_PATTERN, (_, digit: string, period: string) => `${digit}${period.toLowerCase()}m`)
